import React from 'react';

export const eventsRootEl = document.getElementById('portal');

// NOTE: `handler` should be memoized with React.useCallback to prevent running the effect too often
const usePortalCustomEvent = (portalEventName, handler) => {
  React.useEffect(() => {
    const listener = (event: Event) => {
      handler(event ? event.detail : undefined);
    };

    if (eventsRootEl) {
      eventsRootEl.addEventListener(portalEventName, listener);
    }

    return () => {
      if (eventsRootEl) {
        eventsRootEl.removeEventListener(portalEventName, listener);
      }
    };
  }, [portalEventName, handler]);
};

export default usePortalCustomEvent;

// All the events fired from portal, taken from portal-package/**/eventDispatchers.ts
export const portalCustomEvents = {
  FANTASY_APP_MOUNT: 'fantasy_app_mount',
  EVENT_PORTAL_USER_BALANCE_CHANGED: 'user_balance_changed',
  EVENT_PORTAL_LOGGED_IN: 'login',
  EVENT_PORTAL_LOGGED_OUT: 'logout',
  EVENT_PORTAL_PUSH_URL: 'push_url'
};
